export default function ratingsController() {
  let ratingQueue = [];
  let ratingTimeout = null;

  function renderSingleRating(productId, rating, count) {
    const replaceTagTarget = document.getElementById(`product-rating-product-rating-id-${productId}`);

    if (!replaceTagTarget) {
      return;
    }
    document.dispatchEvent(
      new CustomEvent(`product-rating-loaded`, {
        detail: {
          id: productId,
          rating: rating,
          count: count,
        },
      })
    );

    if (!rating || !count) {
      return;
    }

    const ratingValue = rating.toFixed(1);
    const reviewsText = pluralize(count, 'review', 'reviews');

    let ratingHtml = `
      <div class="product-rating color-foreground scroll-trigger animate--fade-in">
        <span class="product-rating__value">
            <span>${ratingValue}</span>
            <span class="visually-hidden">out of 5</span>
        </span>
        <span class="stars">
            ${Array.from({ length: 5 }, (_, i) => {
              const star = i < rating ? '★' : '☆';
              return `<span class="star" aria-hidden="true">${star}</span>`;
            }).join('')}
        </span>
        <span class="product-rating__count">
            <span class="product-rating__count__value">${count}</span>
        </span>
      </div>
    `;

    if (window.template === 'product' && replaceTagTarget.closest('product-info')) {
      ratingHtml = '<a href="#customer-reviews" title="See reviews" class="link-reset">' + ratingHtml + '</a>';
    }

    if (replaceTagTarget) {
      replaceTagTarget.outerHTML = ratingHtml;
    }
  }

  function cacheItemRating(productId, rating, count) {
    const cacheKey = 'products-rating-cache';
    const cachedRatings = JSON.parse(localStorage.getItem(cacheKey)) || {};

    cachedRatings[productId] = {
      rating,
      count,
    };

    localStorage.setItem(cacheKey, JSON.stringify(cachedRatings));
  }

  function getCachedItemRating(productId) {
    const cacheKey = 'products-rating-cache';
    const cachedRatings = JSON.parse(localStorage.getItem(cacheKey)) || {};

    if (cachedRatings[productId]) {
      return cachedRatings[productId];
    }

    return null;
  }

  function renderRating(productId) {
    const cachedRating = getCachedItemRating(productId);

    if (cachedRating) {
      renderSingleRating(productId, cachedRating.rating, cachedRating.count);
    }

    if (ratingTimeout) {
      clearTimeout(ratingTimeout);
    }

    ratingQueue.push(productId);

    ratingTimeout = setTimeout(() => {
      const productIds = ratingQueue.map((id) => ({
        productId: id,
      }));

      fetch('https://stamped.io/api/widget/badges', {
        method: 'POST',
        body: JSON.stringify({
          productIds: productIds,
          sId: window.StampedIOSettings.storeHash,
          apiKey: window.StampedIOSettings.publicAPIKey,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data)) {
            data.forEach(({ productId, rating, count }) => {
              cacheItemRating(productId, rating, count);
              renderSingleRating(productId, rating, count);
              renderSingleRating(productId, rating, count);
            });
          }
        });

      ratingQueue = [];
    }, 50);
  }

  const ratingElementsObserver = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          findRatingElementInNode(node);
        });
      }
    }
  });

  function findRatingElementInNode(node) {
    if (node.nodeType !== 1 || !node.classList) {
      return;
    }

    if (node.classList.contains('grid__item')) {
      const ratingPlace = node.querySelector('div[id^="product-rating-product-rating-id-"]');
      if (ratingPlace) {
        const productId = ratingPlace.id.split('-').pop();
        renderRating(productId);
      }
      return;
    }

    if (node.id.startsWith('product-rating-product-rating-id-')) {
      const productId = node.id.split('-').pop();
      renderRating(productId);
    }

    if (node.classList.contains('product-grid')) {
      const ratingItems = node.querySelectorAll('div[id^="product-rating-product-rating-id-"]');

      if (ratingItems && ratingItems.length) {
        ratingItems.forEach((rating) => {
          const productId = rating.id.split('-').pop();
          renderRating(productId);
        });
      }
    }
  }

  const observeTarget = [];

  const productGrid = document.getElementById('product-grid');

  if (productGrid) {
    observeTarget.push(productGrid);
  }

  const buildYourOwnBundle = document.getElementById('build-your-own-recharge-bundle-container');

  if (buildYourOwnBundle) {
    observeTarget.push(buildYourOwnBundle);
  }

  const recommendations = document.querySelector('product-recommendations.related-products');

  if (recommendations) {
    observeTarget.push(recommendations);
  }

  observeTarget.forEach((target) => {
    ratingElementsObserver.observe(target, {
      childList: true,
      subtree: true,
    });
  });

  //check for rating elements on page load
  document.querySelectorAll('div[id^="product-rating-product-rating-id-"]').forEach((rating) => {
    const productId = rating.id.split('-').pop();
    renderRating(productId);
  });
}
